module.exports = __webpack_public_path__ + "h5/img/service2.db7c5b12.png";